function Status() {
  return (
    <h1>Status</h1>
  );
}

export default Status